import { c as _c } from "react/compiler-runtime";
import { DefaultImage } from '../../shared';
import { type MatchingEventBannerProps } from '../types';
import styles from './MatchingEventBanner.module.css';
import LinkButton from '../../../components/LinkButton';
import { LayoutCluster } from '../../../components/layouts/LayoutCluster';
import { Banner } from '../../../components/Banner';
import Logos from '../Logos';
const logoHeight = 24;
function MatchingEventBanner(t0) {
  const $ = _c(18);
  const {
    Image: t1,
    children,
    color,
    logoSrc,
    logoAlt,
    logoSecondarySrc,
    logoSecondaryAlt,
    buttonText,
    onClick
  } = t0;
  const Image = t1 === undefined ? DefaultImage : t1;
  let t2;
  if ($[0] !== children) {
    t2 = <Banner.TitleBar>{children}</Banner.TitleBar>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== buttonText || $[3] !== onClick) {
    t3 = <LinkButton size="small" onClick={onClick} className={styles.gentleLink} type="button">{buttonText}</LinkButton>;
    $[2] = buttonText;
    $[3] = onClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== Image || $[6] !== logoAlt || $[7] !== logoSecondaryAlt || $[8] !== logoSecondarySrc || $[9] !== logoSrc) {
    t4 = <Logos logoSrc={logoSrc} logoAlt={logoAlt} height={logoHeight} logoSecondarySrc={logoSecondarySrc} logoSecondaryAlt={logoSecondaryAlt} Image={Image} />;
    $[5] = Image;
    $[6] = logoAlt;
    $[7] = logoSecondaryAlt;
    $[8] = logoSecondarySrc;
    $[9] = logoSrc;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <Banner.Content><LayoutCluster className={styles.bottomBar} justify="space-between" flex={true}>{t3}{t4}</LayoutCluster></Banner.Content>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== color || $[15] !== t2 || $[16] !== t5) {
    t6 = <Banner htmlColor={color}>{t2}{t5}</Banner>;
    $[14] = color;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
export default MatchingEventBanner;